import { Auth } from "aws-amplify";
import React, { Component } from "react";
import { models } from "powerbi-client";
import LoaderOverlay from "react-loading-overlay";
import { PowerBIEmbed } from "powerbi-client-react";
import { dashboardUrl, awsUrl } from "../../config/config";
import { getHeader, getHeaderbi } from "../../utils/common";
import Navbar from "../../components/Header/Header";

import { createRef } from "react";
import "./DashBoardWithMap.scss";
// import numeral from 'numeral'

import axios from "axios";

class DashboardWithMap extends Component {
  constructor() {
    super();

    this.reportRef = [createRef(), createRef()];
    // this.loginConfig = {
    //   "shanewrightman@insurecomp.com": {
    //     "5a136030-62e5-4909-ad4a-974a0278f2b0": {
    //       page: "0cbbff6b0ceaa86be167", //libertate
    //       filters: [],
    //     },
    //     "8c6a21c3-b17c-4f4f-b9da-3ce6c278b1d3": {
    //       page: "8d75b20bb241efb24965", //Calender year
    //       filters: [],
    //     },
    //   },
    //   "chayamahaveer@insurecomp.com": {
    //     "5a136030-62e5-4909-ad4a-974a0278f2b0": {
    //       page: "a41fa870bb006ee277ac", //e3 hr
    //       filters: [],
    //     },
    //     "8c6a21c3-b17c-4f4f-b9da-3ce6c278b1d3": {
    //       page: "5a5d45d1adec0d1c81cd", //Fiscal year
    //       filters: [],
    //     },
    //   },
    //   "harshmahtole@insurecomp.com": {
    //     "5a136030-62e5-4909-ad4a-974a0278f2b0": {
    //       page: "",
    //       filters: [
    //         {
    //           $schema: "http://powerbi.com/product/schema#basic",
    //           target: {
    //             table: "libertate",
    //             column: "Month",
    //           },
    //           operator: "In",
    //           values: ["Feb-24"],
    //         },
    //       ],
    //     },
    //     "8c6a21c3-b17c-4f4f-b9da-3ce6c278b1d3": {
    //       page: "",
    //       filters: [
    //         {
    //           $schema: "http://powerbi.com/product/schema#basic",
    //           target: {
    //             table: "Revenue",
    //             column: "DEPARTMENT",
    //           },
    //           operator: "In",
    //           values: ["Alexa"],
    //         },
    //       ],
    //     },
    //   },
    // };

    this.state = {
      user: "",
      isLoader: true,
      embedData: [],
    };
  }

  async onReportLoaded(index) {
    if (!this.reportRef[index].current) return;

    try {
      const report = this.reportRef[index].current["_embed"];

      const currentReportID = report.config.id;
      // const currentLoginReport =
      //   this.loginConfig[this.state.user][currentReportID];
      // const pages = await report.getPages();

      // const targetPage = pages.find((p) => p.name === currentLoginReport.page);
      // if (targetPage) await targetPage.setActive();

      // if (currentLoginReport.filters && currentLoginReport.filters.length > 0)
      //   await report.setFilters(currentLoginReport.filters);
    } catch (error) {
      console.log("Error switching page:", error);
    }
  }

  async getEmbedUrl() {
    try {
      const header = await getHeader();

      const response = await axios.get(
        awsUrl + "/api/getAllReportsEmbedUrl",
        {
          headers: {
            "Content-Type": "application/json",
            ...header.headers,
          },
        }
      );

      this.setState({
        ...this.state,
        isLoader: false,
        embedData: response.data,
      });
    } catch (error) {
      console.log(error);
      this.setState({
        ...this.state,
        isLoader: false,
        embedData: [],
      });
    }
  }

  async componentDidMount() {
    // Auth.currentSession()
    // .then(
    // .catch(err=> console.log(err))

    await Auth.currentUserInfo()
      .then((data) => {
        // console.log(data);
        this.setState({
          user: data.username,
        });
        // console.log(data.username);
      })
      .catch((err) => console.log(err));

    await Auth.currentSession().then((res) => {
      var userRole = res.accessToken.payload["cognito:groups"];
      if (userRole && userRole.length > 0) {
        if (userRole.includes("User")) {
          userRole.push("Agent");
        }
        this.setState({
          user_type: userRole,
        });
      }
    }).catch(err => console.log("Session error:", err));

    console.log("Calling getEmbedUrl...");
    await this.getEmbedUrl();
  }

  render() {
    const { isLoader } = this.state;

    return (
      <div className="reports-page-container">
        <div className="dashboard-header">
          <Navbar sessionData={this.props.sessionData} />
        </div>
        <div className="reports-content-wrapper">
          <LoaderOverlay active={isLoader} spinner text="Loading reports...">
            <div className="power-bi-report-container">
              {this.state.embedData.map((data, index) => {
                return (
                  <PowerBIEmbed
                    key={index}
                    ref={this.reportRef[index]}
                    cssClassName="h-100 mt-3 border-none"
                    embedConfig={{
                      type: "report",
                      embedUrl: data.embedUrl,
                      accessToken: data.accessToken,
                      id: data.id,
                      tokenType: models.TokenType.Embed,
                      settings: {
                        navContentPaneEnabled: false,
                        panes: {
                          filters: { visible: false },
                          pageNavigation: { visible: true },
                        },
                      },
                    }}
                    eventHandlers={
                      new Map([
                        ["loaded", () => this.onReportLoaded(index)],
                        ["error", (event) => console.log(event.detail)],
                      ])
                    }
                  />
                );
              })}
            </div>
          </LoaderOverlay>
        </div>

      </div>
    );
  }
}

export default DashboardWithMap;
